export const NIFTY50 = new Set([
  "ADANIENT", "ADANIPORTS", "APOLLOHOSP", "ASIANPAINT", "AXISBANK",
  "BAJAJ-AUTO", "BAJFINANCE", "BAJAJFINSV", "BHARTIARTL", "BPCL",
  "BRITANNIA", "CIPLA", "COALINDIA", "DIVISLAB", "DRREDDY",
  "EICHERMOT", "ETERNAL", "GRASIM", "HCLTECH", "HDFCBANK",
  "HDFCLIFE", "HEROMOTOCO", "HINDALCO", "HINDUNILVR", "ICICIBANK",
  "INDUSINDBK", "INFY", "ITC", "JSWSTEEL", "KOTAKBANK",
  "LT", "M&M", "MARUTI", "NESTLEIND", "NTPC",
  "ONGC", "POWERGRID", "RELIANCE", "SBILIFE", "SBIN",
  "SHRIRAMFIN", "SUNPHARMA", "TATACONSUM", "TMCV", "TATASTEEL",
  "TCS", "TECHM", "TITAN", "TRENT", "ULTRACEMCO",
]);

export const NIFTY_NEXT_50 = new Set([
  "ADANIENSOL", "ADANIGREEN", "ADANIPOWER", "AMBUJACEM", "BAJAJHLDNG",
  "BANKBARODA", "BEL", "BOSCHLTD", "CHOLAFIN", "DABUR",
  "DLF", "DMART", "GAIL", "GODREJCP", "HAL",
  "HINDZINC", "ICICIGI", "INDIGO", "INDUSTOWER", "IOC",
  "IRFC", "JINDALSTEL", "JSWENERGY", "LODHA", "LUPIN",
  "MANKIND", "MARICO", "MAXHEALTH", "MOTHERSON", "MUTHOOTFIN",
  "NHPC", "OIL", "PATANJALI", "PFC", "PIDILITIND",
  "POLICYBZR", "POLYCAB", "PRESTIGE", "RECLTD", "SBICARD",
  "SHREECEM", "SIEMENS", "SOLARINDS", "SUZLON", "TATAPOWER",
  "TORNTPHARM", "TVSMOTOR", "UNIONBANK", "VEDL", "YESBANK",
]);

// Nifty 100 = Nifty 50 + Nifty Next 50
export const NIFTY100 = new Set([...NIFTY50, ...NIFTY_NEXT_50]);

export const SENSEX30 = new Set([
  "ADANIENT", "AXISBANK", "BAJFINANCE", "BAJAJFINSV", "BHARTIARTL",
  "HCLTECH", "HDFCBANK", "HINDUNILVR", "ICICIBANK", "INDUSINDBK",
  "INFY", "ITC", "JSWSTEEL", "KOTAKBANK", "LT",
  "M&M", "MARUTI", "NESTLEIND", "NTPC", "POWERGRID",
  "RELIANCE", "SBIN", "SUNPHARMA", "TMCV", "TATASTEEL",
  "TCS", "TECHM", "TITAN", "TRENT", "ULTRACEMCO",
]);

export const NIFTY200 = new Set([
  "360ONE", "ABB", "ABCAPITAL", "ADANIENSOL", "ADANIENT",
  "ADANIGREEN", "ADANIPORTS", "ADANIPOWER", "ALKEM", "AMBUJACEM",
  "APLAPOLLO", "APOLLOHOSP", "ASHOKLEY", "ASIANPAINT", "ASTRAL",
  "ATGL", "AUBANK", "AUROPHARMA", "AXISBANK", "BAJAJ-AUTO",
  "BAJAJFINSV", "BAJAJHLDNG", "BAJFINANCE", "BANKBARODA", "BANKINDIA",
  "BDL", "BEL", "BHARATFORG", "BHARTIARTL", "BHEL",
  "BIOCON", "BLUESTARCO", "BOSCHLTD", "BPCL", "BRITANNIA",
  "BSE", "CANBK", "CGPOWER", "CHOLAFIN", "CIPLA",
  "COALINDIA", "COCHINSHIP", "COFORGE", "COLPAL", "CONCOR",
  "COROMANDEL", "CUMMINSIND", "DABUR", "DIVISLAB", "DIXON",
  "DLF", "DMART", "DRREDDY", "EICHERMOT", "ENRIN",
  "ETERNAL", "EXIDEIND", "FEDERALBNK", "FORTIS", "GAIL",
  "GLENMARK", "GMRAIRPORT", "GODFRYPHLP", "GODREJCP", "GODREJPROP",
  "GRASIM", "GROWW", "GVT&D", "HAL", "HAVELLS",
  "HCLTECH", "HDFCAMC", "HDFCBANK", "HDFCLIFE", "HEROMOTOCO",
  "HINDALCO", "HINDPETRO", "HINDUNILVR", "HINDZINC", "HUDCO",
  "HYUNDAI", "ICICIAMC", "ICICIBANK", "ICICIGI", "IDEA",
  "IDFCFIRSTB", "INDHOTEL", "INDIANB", "INDIGO", "INDUSINDBK",
  "INDUSTOWER", "INFY", "IOC", "IRCTC", "IREDA",
  "IRFC", "ITC", "JINDALSTEL", "JIOFIN", "JSWENERGY",
  "JSWSTEEL", "JUBLFOOD", "KALYANKJIL", "KEI", "KOTAKBANK",
  "KPITTECH", "LAURUSLABS", "LENSKART", "LGEINDIA", "LICHSGFIN",
  "LODHA", "LT", "LTF", "LTM", "LUPIN",
  "M&M", "M&MFIN", "MANKIND", "MARICO", "MARUTI",
  "MAXHEALTH", "MAZDOCK", "MCX", "MFSL", "MOTHERSON",
  "MOTILALOFS", "MPHASIS", "MRF", "MUTHOOTFIN", "NATIONALUM",
  "NAUKRI", "NESTLEIND", "NHPC", "NMDC", "NTPC",
  "NYKAA", "OBEROIRLTY", "OFSS", "OIL", "ONGC",
  "PAGEIND", "PATANJALI", "PAYTM", "PERSISTENT", "PFC",
  "PHOENIXLTD", "PIDILITIND", "PIIND", "PNB", "POLICYBZR",
  "POLYCAB", "POWERGRID", "POWERINDIA", "PREMIERENE", "PRESTIGE",
  "RADICO", "RECLTD", "RELIANCE", "RVNL", "SAIL",
  "SBICARD", "SBILIFE", "SBIN", "SHREECEM", "SHRIRAMFIN",
  "SIEMENS", "SOLARINDS", "SRF", "SUNPHARMA", "SUPREMEIND",
  "SUZLON", "SWIGGY", "TATACAP", "TATACOMM", "TATACONSUM",
  "TATAELXSI", "TATAINVEST", "TATAPOWER", "TATASTEEL", "TCS",
  "TECHM", "TIINDIA", "TITAN", "TMCV", "TMPV",
  "TORNTPHARM", "TRENT", "TVSMOTOR", "ULTRACEMCO", "UNIONBANK",
  "UNITDSPR", "UPL", "VBL", "VEDL", "VMM",
  "VOLTAS", "WAAREEENER", "WIPRO", "YESBANK", "ZYDUSLIFE",
]);

export const NIFTY500 = new Set([
  "360ONE", "3MINDIA", "AADHARHFC", "AARTIIND", "AAVAS",
  "ABB", "ABBOTINDIA", "ABCAPITAL", "ABDL", "ABFRL",
  "ABLBL", "ABREL", "ABSLAMC", "ACC", "ACE",
  "ACMESOLAR", "ACUTAAS", "ADANIENSOL", "ADANIENT", "ADANIGREEN",
  "ADANIPORTS", "ADANIPOWER", "AEGISLOG", "AEGISVOPAK", "AFCONS",
  "AFFLE", "AIAENG", "AIIL", "AJANTPHARM", "ALKEM",
  "AMBER", "AMBUJACEM", "ANANDRATHI", "ANANTRAJ", "ANGELONE",
  "ANTHEM", "ANURAS", "APARINDS", "APLAPOLLO", "APOLLOHOSP",
  "APOLLOTYRE", "APTUS", "ARE&M", "ASAHIINDIA", "ASHOKLEY",
  "ASIANPAINT", "ASTERDM", "ASTRAL", "ATGL", "ATHERENERG",
  "ATUL", "AUBANK", "AUROPHARMA", "AWL", "AXISBANK",
  "BAJAJ-AUTO", "BAJAJFINSV", "BAJAJHFL", "BAJAJHLDNG", "BAJFINANCE",
  "BALKRISIND", "BALRAMCHIN", "BANDHANBNK", "BANKBARODA", "BANKINDIA",
  "BATAINDIA", "BAYERCROP", "BBTC", "BDL", "BEL",
  "BELRISE", "BEML", "BERGEPAINT", "BHARATFORG", "BHARTIARTL",
  "BHARTIHEXA", "BHEL", "BIKAJI", "BIOCON", "BLS",
  "BLUEDART", "BLUEJET", "BLUESTARCO", "BOSCHLTD", "BPCL",
  "BRIGADE", "BRITANNIA", "BSE", "BSOFT", "CAMS",
  "CANBK", "CANFINHOME", "CANHLIFE", "CAPLIPOINT", "CARBORUNIV",
  "CARTRADE", "CASTROLIND", "CCL", "CDSL", "CEATLTD",
  "CEMPRO", "CENTRALBK", "CESC", "CGCL", "CGPOWER",
  "CHALET", "CHAMBLFERT", "CHENNPETRO", "CHOICEIN", "CHOLAFIN",
  "CHOLAHLDNG", "CIEINDIA", "CIPLA", "CLEAN", "COALINDIA",
  "COCHINSHIP", "COFORGE", "COHANCE", "COLPAL", "CONCOR",
  "CONCORDBIO", "COROMANDEL", "CPPLUS", "CRAFTSMAN", "CREDITACC",
  "CRISIL", "CROMPTON", "CUB", "CUMMINSIND", "CYIENT",
  "DABUR", "DALBHARAT", "DATAPATTNS", "DCMSHRIRAM", "DEEPAKFERT",
  "DEEPAKNTR", "DELHIVERY", "DEVYANI", "DIVISLAB", "DIXON",
  "DLF", "DMART", "DOMS", "DRREDDY", "ECLERX",
  "EICHERMOT", "EIDPARRY", "EIHOTEL", "ELECON", "ELGIEQUIP",
  "EMAMILTD", "EMCURE", "EMMVEE", "ENDURANCE", "ENGINERSIN",
  "ENRIN", "ERIS", "ESCORTS", "ETERNAL", "EXIDEIND",
  "FACT", "FEDERALBNK", "FINCABLES", "FIRSTCRY", "FIVESTAR",
  "FLUOROCHEM", "FORCEMOT", "FORTIS", "FSL", "GABRIEL",
  "GAIL", "GALLANTT", "GESHIP", "GICRE", "GILLETTE",
  "GLAND", "GLAXO", "GLENMARK", "GMDCLTD", "GMRAIRPORT",
  "GODFRYPHLP", "GODIGIT", "GODREJCP", "GODREJIND", "GODREJPROP",
  "GPIL", "GRANULES", "GRAPHITE", "GRASIM", "GRAVITA",
  "GROWW", "GRSE", "GVT&D", "HAL", "HAVELLS",
  "HBLENGINE", "HCLTECH", "HDBFS", "HDFCAMC", "HDFCBANK",
  "HDFCLIFE", "HEG", "HEROMOTOCO", "HEXT", "HFCL",
  "HINDALCO", "HINDCOPPER", "HINDPETRO", "HINDUNILVR", "HINDZINC",
  "HOMEFIRST", "HONASA", "HONAUT", "HSCL", "HUDCO",
  "HYUNDAI", "ICICIAMC", "ICICIBANK", "ICICIGI", "ICICIPRULI",
  "IDBI", "IDEA", "IDFCFIRSTB", "IEX", "IFCI",
  "IGIL", "IGL", "IIFL", "IKS", "INDGN",
  "INDHOTEL", "INDIACEM", "INDIAMART", "INDIANB", "INDIGO",
  "INDUSINDBK", "INDUSTOWER", "INFY", "INOXWIND", "INTELLECT",
  "IOB", "IOC", "IPCALAB", "IRB", "IRCON",
  "IRCTC", "IREDA", "IRFC", "ITC", "ITCHOTELS",
  "ITI", "J&KBANK", "JAINREC", "JBCHEPHARM", "JBMA",
  "JINDALSAW", "JINDALSTEL", "JIOFIN", "JKCEMENT", "JKTYRE",
  "JMFINANCIL", "JPPOWER", "JSL", "JSWCEMENT", "JSWDULUX",
  "JSWENERGY", "JSWINFRA", "JSWSTEEL", "JUBLFOOD", "JUBLINGREA",
  "JUBLPHARMA", "JWL", "JYOTICNC", "KAJARIACER", "KALYANKJIL",
  "KARURVYSYA", "KAYNES", "KEC", "KEI", "KFINTECH",
  "KIMS", "KIRLOSENG", "KOTAKBANK", "KPIL", "KPITTECH",
  "KPRMILL", "LALPATHLAB", "LATENTVIEW", "LAURUSLABS", "LEMONTREE",
  "LENSKART", "LGEINDIA", "LICHSGFIN", "LICI", "LINDEINDIA",
  "LLOYDSME", "LODHA", "LT", "LTF", "LTFOODS",
  "LTM", "LTTS", "LUPIN", "M&M", "M&MFIN",
  "MAHABANK", "MANAPPURAM", "MANKIND", "MAPMYINDIA", "MARICO",
  "MARUTI", "MAXHEALTH", "MAZDOCK", "MCX", "MEDANTA",
  "MEESHO", "MFSL", "MGL", "MINDACORP", "MMTC",
  "MOTHERSON", "MOTILALOFS", "MPHASIS", "MRF", "MRPL",
  "MSUMI", "MUTHOOTFIN", "NAM-INDIA", "NATCOPHARM", "NATIONALUM",
  "NAUKRI", "NAVA", "NAVINFLUOR", "NBCC", "NCC",
  "NESTLEIND", "NETWEB", "NEULANDLAB", "NEWGEN", "NH",
  "NHPC", "NIACL", "NIVABUPA", "NLCINDIA", "NMDC",
  "NSLNISP", "NTPC", "NTPCGREEN", "NUVAMA", "NUVOCO",
  "NYKAA", "OBEROIRLTY", "OFSS", "OIL", "OLAELEC",
  "OLECTRA", "ONESOURCE", "ONGC", "PAGEIND", "PARADEEP",
  "PATANJALI", "PAYTM", "PCBL", "PERSISTENT", "PETRONET",
  "PFC", "PFIZER", "PGEL", "PHOENIXLTD", "PIDILITIND",
  "PIIND", "PINELABS", "PIRAMALFIN", "PNB", "PNBHOUSING",
  "POLICYBZR", "POLYCAB", "POLYMED", "POONAWALLA", "POWERGRID",
  "POWERINDIA", "PPLPHARMA", "PREMIERENE", "PRESTIGE", "PTCIL",
  "PVRINOX", "PWL", "RADICO", "RAILTEL", "RAINBOW",
  "RAMCOCEM", "RBLBANK", "RECLTD", "REDINGTON", "RELIANCE",
  "RHIM", "RITES", "RKFORGE", "RPOWER", "RRKABEL",
  "RVNL", "SAGILITY", "SAIL", "SAILIFE", "SAMMAANCAP",
  "SAPPHIRE", "SARDAEN", "SAREGAMA", "SBFC", "SBICARD",
  "SBILIFE", "SBIN", "SCHAEFFLER", "SCHNEIDER", "SCI",
  "SHREECEM", "SHRIRAMFIN", "SHYAMMETL", "SIEMENS", "SIGNATURE",
  "SJVN", "SOBHA", "SOLARINDS", "SONACOMS", "SONATSOFTW",
  "SPLPETRO", "SRF", "STARHEALTH", "SUMICHEM", "SUNDARMFIN",
  "SUNPHARMA", "SUNTV", "SUPREMEIND", "SUZLON", "SWANCORP",
  "SWIGGY", "SYNGENE", "SYRMA", "TARIL", "TATACAP",
  "TATACHEM", "TATACOMM", "TATACONSUM", "TATAELXSI", "TATAINVEST",
  "TATAPOWER", "TATASTEEL", "TATATECH", "TBOTEK", "TCS",
  "TECHM", "TECHNOE", "TEGA", "TEJASNET", "TENNIND",
  "THELEELA", "THERMAX", "TIINDIA", "TIMKEN", "TITAGARH",
  "TITAN", "TMCV", "TMPV", "TORNTPHARM", "TORNTPOWER",
  "TRAVELFOOD", "TRENT", "TRIDENT", "TRITURBINE", "TTML",
  "TVSMOTOR", "UBL", "UCOBANK", "ULTRACEMCO", "UNIONBANK",
  "UNITDSPR", "UNOMINDA", "UPL", "URBANCO", "USHAMART",
  "UTIAMC", "VBL", "VEDL", "VIJAYA", "VMM",
  "VOLTAS", "VTL", "WAAREEENER", "WELCORP", "WELSPUNLIV",
  "WHIRLPOOL", "WIPRO", "WOCKPHARMA", "YESBANK", "ZEEL",
  "ZENSARTECH", "ZENTEC", "ZFCVINDIA", "ZYDUSLIFE", "ZYDUSWELL",
]);

export type UniverseKey = 'ALL' | 'NIFTY50' | 'NIFTYNEXT50' | 'NIFTY100' | 'NIFTY200' | 'NIFTY500' | 'SENSEX30' | 'HOLDINGS';

export const UNIVERSE_LABELS: Record<UniverseKey, string> = {
  ALL:         'All 500',
  NIFTY50:     'Nifty 50',
  NIFTYNEXT50: 'Nifty Next 50',
  NIFTY100:    'Nifty 100',
  NIFTY200:    'Nifty 200',
  NIFTY500:    'Nifty 500',
  SENSEX30:    'Sensex 30',
  HOLDINGS:    'My Holdings',
};
